exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-farm-dialog .mat-dialog-actions button {\n  text-transform: uppercase; }\n\napp-farm-dialog .input-spinner {\n  float: right;\n  margin-left: 8px; }\n", ""]);

// exports
